<script setup lang="ts">
import { ref } from 'vue';

const props = defineProps<{
  id?: string;
  value: string;
  placeholder?: string;
  rows?: number;
  emitChangeOnInput?: boolean;
  maxLength?: number;
  disabled?: boolean;
}>();

const emits = defineEmits<{
  change: [value: string];
}>();

const handleChange = (e: Event) => {
  emits('change', (e.target as HTMLTextAreaElement).value);
};

const textareaRef = ref<HTMLTextAreaElement | null>(null);

const focus = () => {
  textareaRef.value?.focus();
};

defineExpose({
  focus,
});
</script>

<template>
  <div class="flex w-full">
    <textarea
      :id="props.id"
      ref="textareaRef"
      class="ring-primary-500 m-[2px] flex-1 rounded-md border border-slate-200 bg-white p-2 text-sm text-slate-900 outline-none focus:ring-2"
      :value="props.value"
      :placeholder="props.placeholder"
      :rows="props.rows ?? 6"
      :maxlength="props.maxLength"
      :disabled="props.disabled"
      :class="
        props.disabled ? 'cursor-not-allowed bg-slate-50 text-slate-400' : ''
      "
      @change="handleChange"
      @input="(e) => props.emitChangeOnInput && handleChange(e)"
    />
  </div>
</template>
